import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "grid pb-2" }
const _hoisted_3 = { class: "icon" }
const _hoisted_4 = { class: "action-details grid" }
const _hoisted_5 = { class: "col sm:col-8" }
const _hoisted_6 = { class: "col sm:col-4" }
const _hoisted_7 = { class: "col sm:col-8" }
const _hoisted_8 = { class: "col sm:col-4" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "icon" }
const _hoisted_11 = { class: "button-container border" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "text-center pt-2" }
const _hoisted_14 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActionHeader = _resolveComponent("ActionHeader")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Tags = _resolveComponent("Tags")!
  const _component_FormInput = _resolveComponent("FormInput")!
  const _component_Wysiwyg = _resolveComponent("Wysiwyg")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.action?.id)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_ActionHeader, {
          actionTitle: _ctx.actionHotspotHeading,
          actionDescription: _ctx.actionHotspotDescription
        }, null, 8, ["actionTitle", "actionDescription"]),
        _createVNode(_component_Form, {
          modelValue: _ctx.model,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model) = $event)),
          schema: _ctx.schema
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                class: _normalizeClass(["col jaccordion", { open: _ctx.showDetails, closed: !_ctx.showDetails }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleJaccordion('details')))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.translateText("action.edit.title.details")), 1),
                _createElementVNode("span", _hoisted_3, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: _ctx.showDetails ? 'chevron-down' : 'chevron-right'
                  }, null, 8, ["icon"])
                ])
              ], 2),
              (_ctx.action?.level === 'user' && _ctx.isMounted && _ctx.componentMounted)
                ? (_openBlock(), _createBlock(_Teleport, {
                    key: 0,
                    to: ".user-select"
                  }, [
                    _createVNode(_component_Select, {
                      value: _ctx.selectedUser,
                      error: "",
                      items: _ctx.users,
                      label: "action.edit.level.user",
                      name: "user",
                      id: "user",
                      onChange: _ctx.changeUser
                    }, null, 8, ["value", "items", "onChange"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.action?.level === 'group' && _ctx.isMounted && _ctx.componentMounted)
                ? (_openBlock(), _createBlock(_Teleport, {
                    key: 1,
                    to: ".group-select"
                  }, [
                    _createVNode(_component_Select, {
                      value: _ctx.selectedGroup,
                      error: "",
                      items: _ctx.groups,
                      label: "action.edit.level.group",
                      name: "group",
                      id: "group",
                      onChange: _ctx.changeGroup
                    }, null, 8, ["value", "items", "onChange"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.action?.level === 'tag' && _ctx.isMounted && _ctx.componentMounted)
                ? (_openBlock(), _createBlock(_Teleport, {
                    key: 2,
                    to: ".group-select"
                  }, [
                    _createVNode(_component_Tags, {
                      onTagsChanged: _ctx.handleTagsChanged,
                      user: _ctx.model,
                      value: _ctx.selectedTags
                    }, null, 8, ["onTagsChanged", "user", "value"])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_Transition, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["w-100", { hidden: !_ctx.showDetails }])
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_Select, {
                          value: _ctx.action?.actionType ?? '',
                          error: "",
                          items: _ctx.typeSelectOptions,
                          label: "action.edit.type",
                          name: "type",
                          id: "type",
                          disabled: ""
                        }, null, 8, ["value", "items"])
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_Select, {
                          value: _ctx.action?.level ?? '',
                          error: "",
                          items: _ctx.levelSelectOptions,
                          label: "action.edit.audience",
                          name: "level",
                          id: "level",
                          disabled: ""
                        }, null, 8, ["value", "items"])
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_FormInput, {
                          value: _ctx.model.title,
                          id: "edit-document-title",
                          name: "title",
                          label: "action.edit.details.title",
                          onChange: _ctx.handleChange
                        }, null, 8, ["value", "onChange"])
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_FormInput, {
                          value: _ctx.model.sideMenuText,
                          id: "edit-document-side-menu-text",
                          name: "sideMenuText",
                          label: "action.edit.details.side-menu",
                          onChange: _ctx.handleChange
                        }, null, 8, ["value", "onChange"])
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_Wysiwyg, {
                          value: _ctx.model.description,
                          label: "action.edit.details.description",
                          name: "description",
                          classes: "mini",
                          onInputChange: _ctx.handleDataChange
                        }, null, 8, ["value", "onInputChange"])
                      ])
                    ])
                  ], 2)
                ]),
                _: 1
              }),
              _createElementVNode("div", {
                class: _normalizeClass(["col jaccordion", { open: _ctx.showContent, closed: !_ctx.showContent }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleJaccordion('content')))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.translateText("action.edit.title.content")), 1),
                _createElementVNode("span", _hoisted_10, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: _ctx.showContent ? 'chevron-down' : 'chevron-right'
                  }, null, 8, ["icon"])
                ])
              ], 2),
              _createVNode(_Transition, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["w-100", { hidden: !_ctx.showContent }])
                  }, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentComponent), {
                      key: _ctx.getComponentKey,
                      class: "action-content",
                      action: _ctx.action,
                      updateActive: _ctx.updateActive,
                      selectedUser: _ctx.selectedUser,
                      selectedGroup: _ctx.selectedGroup,
                      selectedTags: _ctx.selectedTags,
                      onUpdated: _ctx.handleComponentSave,
                      onModifyModel: _ctx.handleChange,
                      onUpdateSchema: _ctx.handleUpdateSchema,
                      onIsLoaded: _ctx.handleComponentMounted
                    }, null, 40, ["action", "updateActive", "selectedUser", "selectedGroup", "selectedTags", "onUpdated", "onModifyModel", "onUpdateSchema", "onIsLoaded"]))
                  ], 2)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_Button, {
                text: "common.save",
                disabled: !_ctx.isDirty,
                onClick: _ctx.handleSave
              }, null, 8, ["disabled", "onClick"]),
              _createVNode(_component_Button, {
                text: "common.delete",
                onClick: _ctx.handleDelete,
                variant: "error"
              }, null, 8, ["onClick"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "schema"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("img", {
            src: require('@/assets/img/file_management.svg'),
            alt: "",
            class: "mb-1"
          }, null, 8, _hoisted_14),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "type-subtitle-03 mb-1" }, "No Actions Found", -1)),
          _cache[4] || (_cache[4] = _createElementVNode("p", { class: "mb-1" }, " This hotspot currently has no actions, use the Add New Action button on the left to get started ", -1)),
          _createVNode(_component_Button, {
            class: "mb-1",
            text: "Delete Hotspot",
            variant: "error",
            onClick: _ctx.handleHotspotDelete
          }, null, 8, ["onClick"])
        ])
      ]))
}